import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';
const Settings = lazy(() => import('@/pages/Settings'));
const Integrations = lazy(() => import('@/pages/Integrations'));
const DpaSettings = lazy(() => import('@/pages/settings/DpaSettings'));

/**
 * The /settings page and the pages its tiles open for every settings viewer, behind one guard.
 *
 * The DPA page sits here, under the same guard as the Indstillinger page that shows its tile, so the
 * tile and the page can never disagree: a partner-plan company sees the tile and must also reach the
 * page. Called as a function (not rendered as a component) because `<Routes>` only accepts `<Route>`
 * elements.
 */
export function settingsRoutes() {
  return (
    <Route element={<ProtectedRoute permission="settings.view" allowPartner />}>
      <Route path="settings" element={<Settings />} />
      <Route path="settings/databehandleraftale" element={<DpaSettings />} />
      <Route path="marketplace" element={<Integrations />} />
      <Route path="integrations" element={<Integrations />} />
      {/* e-conomic and Danløn OAuth callbacks redirect the browser back to
          /settings/integrations?economic=… / ?danlon=… (see the backends'
          WebSettingsRedirectUrl). Serve the same integrations page here so
          that landing renders instead of falling through to a blank/redirect. */}
      <Route path="settings/integrations" element={<Integrations />} />
    </Route>
  );
}
